import { render, staticRenderFns } from "./ModalAssignedCollaborators.vue?vue&type=template&id=dcb90054&scoped=true&"
import script from "./ModalAssignedCollaborators.vue?vue&type=script&lang=js&"
export * from "./ModalAssignedCollaborators.vue?vue&type=script&lang=js&"
import style0 from "./ModalAssignedCollaborators.vue?vue&type=style&index=0&id=dcb90054&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb90054",
  null
  
)

export default component.exports